import { AnimatePresence } from "motion/react";
import { ReactNode } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import { AccessControl } from "@ryde/controls";
import { AnimatedPage } from "@ryde/layout";
import {
  RIDE_ADD_PAGE_TRANSITION_DURATION,
  RIDE_EDIT_PAGE_TRANSITION_DURATION,
} from "@ryde/shared";

import { RideEdit } from "../crud";

export const RidesRoutes = (): ReactNode => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route
          path="add"
          element={
            <AccessControl entity="ride" action="create">
              <AnimatedPage durationSeconds={RIDE_ADD_PAGE_TRANSITION_DURATION}>
                <RideEdit isAddRoute />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="add/:id"
          element={
            <AccessControl entity="ride" action="update">
              <AnimatedPage durationSeconds={RIDE_ADD_PAGE_TRANSITION_DURATION}>
                <RideEdit isAddRoute />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
        <Route
          path="edit/:id"
          element={
            <AccessControl entity="ride" action="read">
              <AnimatedPage
                durationSeconds={RIDE_EDIT_PAGE_TRANSITION_DURATION}
              >
                <RideEdit />
              </AnimatedPage>
            </AccessControl>
          }
        ></Route>
      </Routes>
    </AnimatePresence>
  );
};
